import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DirectoryContext from '../../context/directoryManagementContext';
import PageHeading from '../PageHeading';
import PartyMemberList from './party/PartyMemberList';
import OtherContactList from './other/OtherContactList';
import AddPartyMember from './party/AddPartyMember';
import AddOtherContact from './other/AddOtherContact';

const DirectoryTabs = () => {
  const [activeTab, setActiveTab] = useState('other-contacts');
  const location = useLocation();
  const navigate = useNavigate();
  const directoryContext = useContext(DirectoryContext);

  useEffect(() => {
    if (location.pathname.includes('other-contacts')) {
      setActiveTab('other-contacts');
    } else {
      setActiveTab('party-members');
    }
  }, [location.pathname]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    navigate(`../${tab}`);
  };

  const handleModal = () => {
    directoryContext.updateOpenModal(true);
  };

  return (
    <>
      <PageHeading
        pageTitle={activeTab === 'party-members' ? 'Party Directory' : 'Personal Directory'}
        pageModalTitle={`+ Add New ${activeTab === 'party-members' ? 'Party Member' : 'Contact'}`}
        pageModalOpen={handleModal}
      />
      <div className="user-table-wrapper mt-5">
        <div className="tabs1">
          <div className="user-table-tabs">
          <button
              className={`tab-button ml-5 ${activeTab === 'other-contacts' ? 'active' : ''}`}
              onClick={() => handleTabChange('other-contacts')}
            >
              Personal Directory
            </button>
            <button
              className={`tab-button ${activeTab === 'party-members' ? 'active' : ''}`}
              onClick={() => handleTabChange('party-members')}
            >
              Party Directory
            </button>
            
          </div>
        </div>
        <div className="tab-content">
          {activeTab === 'party-members' && <PartyMemberList />}
          {activeTab === 'other-contacts' && <OtherContactList />}
        </div>
      </div>

      {/* Modal Forms */}
      {activeTab === 'party-members' && (
        <AddPartyMember
          isOpen={directoryContext.isOpenModal}
          isAddMode={directoryContext.isAddMode}
        />
      )}
      {activeTab === 'other-contacts' && (
        <AddOtherContact
          isOpen={directoryContext.isOpenModal}
          isAddMode={directoryContext.isAddMode}
        />
      )}
    </>
  );
};

export default DirectoryTabs;
